import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'

const endpoints = (baseURL => {
  return {
    // search email campaigns
    getEmailCampaignByIdMessage: (idMessage, idList) =>
      `${baseURL}/api/lists/${encodeURIComponent(
        idList
      )}/messages/${encodeURIComponent(idMessage)}/campaign`,
    // sources
    getArrayOfSourcesByIdList: idList =>
      `${baseURL}/api/lists/${idList}/sources`
  }
})(process.env.CAMPAIGNS_BUILDER_API_URL)

export const campaignsBuilderGetEmailCampaignByIdMessage = (
  idMessage,
  idList
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailCampaignByIdMessage(idMessage, idList)
  }).then(extractApiData)
}

export const campaignsBuilderGetArrayOfSourcesByIdList = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getArrayOfSourcesByIdList(idList)
  }).then(extractApiData)
}

export const CAMPAIGN_CHANNEL_TYPE_EMAIL = 1
export const CAMPAIGN_CHANNEL_TYPE_MESSENGER = 2
